module.exports = __webpack_public_path__ + "static/media/PM99.51bdd11f.JPG";